import React, { useState } from "react";
import { Pie } from "react-chartjs-2";
import "chart.js/auto";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSearchDollar } from "react-icons/fa";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import StackedBarChart from "./BarGraph";
import { dangerColor, formatNumberForIndia } from "../../utils/comman/Common";
import { useSelector } from "react-redux";

export default function MidSections({
  pieDataPayin,
  pieDatapayout,
  pieOptions,
  barDataPin,
  barDataPout,
  selectedDatePin,
  handleDateChangePin,
  selectedDatePout,
  handleDateChangePout,
  options,
  today,
  transactionStatuswithAmountPinBar,
  transactionStatuswithAmountPoutBar,
}) {
  const [balanceLoader, setBalanceLoader] = useState(false);
  const balance = useSelector(
    (state) => state?.getbalanceresucer?.getbalancelist
  );
  const showBal = (balance) => {
    if (
      balance?.balance !== undefined &&
      balance?.balance >= 0 &&
      !balanceLoader
    ) {
      return <>{formatNumberForIndia(balance?.balance)}</>;
    } else if (balance?.balance < 0 && !balanceLoader) {
      return <span style={{ color: dangerColor }}>{"NA"}</span>;
    } else if (balance?.errCode !== undefined && !balanceLoader) {
      return <span style={{ color: dangerColor }}>{"NA"}</span>;
    } else {
      return <FaSearchDollar size={15} />;
    }
  };
  const payInType = "payin";
  const payoutType = "payout";
  const showTotalWalletBalance = (bal, type) => {
    return (
      Array.isArray(bal) &&
      bal.map((balance, index) => {
        if (balance.type == type) {
          return showBal(balance);
        }
      })
    );
  };
  function checkDataValues(dataset) {
    if (
      !dataset ||
      !Array.isArray(dataset.datasets) ||
      dataset.datasets.length === 0
    ) {
      throw new Error("Invalid dataset format or empty datasets array.");
    }

    const data = dataset.datasets[0].data; // Assuming there's only one dataset

    if (!Array.isArray(data) || data.length === 0) {
      throw new Error("Invalid data format or empty data array.");
    }

    const allZeros = data.every((value) => value === 0);
    return allZeros;
  }

  const renderPieChartWithLegend = (data, options, title) => (
    <div className="row">
      {console.log("data,", data)}
      {console.log("options,", options)}
      <div className="col-lg-8 col-md-12">
        <div style={{ width: "100%", height: "215px" }}>
          {checkDataValues(data) ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                color: "#aaa",
              }}
            >
              No Data Available
            </div>
          ) : (
            <Pie
              data={data}
              options={{ ...options, maintainAspectRatio: false }}
            /> /* Set maintainAspectRatio to false */
          )}
        </div>
      </div>
      <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-center align-items-center">
        <div className="pie-chart-legend">
          {data.labels.map((label, index) => {
            const totalTransactions = data.datasets[0].data.reduce(
              (acc, value) => acc + value,
              0
            );
            const currentTransactions = data.datasets[0].data[index];
            const currentAmount = data.datasets[0].amountData[index];
            const percentage = (
              (currentTransactions / totalTransactions) *
              100
            ).toFixed(2);
            console.log("percentage", percentage);
            return (
              <div
                key={index}
                style={{
                  color:
                    label === "SUCCESS"
                      ? "#61bd6d"
                      : label === "FAILED"
                      ? "#d9534f"
                      : "#f0ad4e",
                  marginBottom: "5px",
                  fontWeight: "500",
                }}
              >
                {`${currentTransactions} Txns, ₹ ${currentAmount?.toLocaleString()}, (${
                  percentage !== undefined &&
                  percentage !== null &&
                  percentage !== "NaN"
                    ? percentage
                    : "0"
                }%)`}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div
          className="col-12 col-md-6"
          style={{ borderRight: "1px solid #eee", padding: "20px" }}
        >
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="text-center mb-0">PAY-IN</h5>{" "}
            <span style={{ paddingLeft: "10px" }}>
              ₹ {showTotalWalletBalance(balance, payInType)}
            </span>
            <div className="ml-auto" style={{ width: "150px" }}>
              <input
                type="date"
                value={selectedDatePin}
                onChange={handleDateChangePin}
                className="form-control"
                max={today}
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              {renderPieChartWithLegend(pieDataPayin, pieOptions, "PAY-IN")}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <StackedBarChart
                barDataPin={transactionStatuswithAmountPinBar}
                from={"payin"}
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6" style={{ padding: "20px" }}>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="text-center mb-0">PAY-OUT</h5>
            <span style={{ paddingLeft: "10px" }}>
              ₹ {showTotalWalletBalance(balance, payoutType)}
            </span>
            <div className="ml-auto" style={{ width: "150px" }}>
              <input
                type="date"
                value={selectedDatePout}
                onChange={handleDateChangePout}
                className="form-control"
                max={today}
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              {renderPieChartWithLegend(pieDatapayout, pieOptions, "PAY-OUT")}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <StackedBarChart
                barDataPin={transactionStatuswithAmountPoutBar}
                from={"payout"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
